/* Cart drawer behaviour.
 *
 * The Webflow runtime opens and closes the drawer, marks the state by setting
 * `data-cart-open` on the cart wrapper, and already closes on a backdrop click.
 * What it does not do is stop the page behind from scrolling, or close on
 * Escape. Those are added here rather than by touching the runtime.
 *
 * Closing is done by dispatching the same `wf-change-cart-state` event the
 * runtime listens for, so this file never has to know how close is implemented.
 */
(function () {
  var wrappers = document.querySelectorAll('[data-node-type="commerce-cart-wrapper"]');
  if (!wrappers.length || !window.MutationObserver) return;

  var scrollY = 0;
  var openWrapper = null;

  function close(wrapper) {
    wrapper.dispatchEvent(
      new CustomEvent('wf-change-cart-state', { bubbles: true, detail: { open: false } })
    );
  }

  /* iOS ignores `overflow: hidden` on the body in enough cases to be unreliable,
     so the page is pinned in place instead and the scroll position restored on
     close. Without this the page behind scrolls under the drawer whenever the
     item list is already at its end.

     The guard matters on templates that render two cart wrappers — search does —
     where locking twice would read pageYOffset off an already-pinned body, get 0,
     and drop the customer at the top of the page on close. */
  function lock() {
    if (document.body.style.position === 'fixed') return;
    scrollY = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlock() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  Array.prototype.forEach.call(wrappers, function (wrapper) {
    new MutationObserver(function () {
      var isOpen = wrapper.hasAttribute('data-cart-open');
      if (isOpen && openWrapper !== wrapper) {
        openWrapper = wrapper;
        lock();
        var closeLink = wrapper.querySelector('[data-node-type="commerce-cart-close-link"]');
        if (closeLink) closeLink.focus();
      } else if (!isOpen && openWrapper === wrapper) {
        openWrapper = null;
        unlock();
      }
    }).observe(wrapper, { attributes: true, attributeFilter: ['data-cart-open'] });
  });

  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Escape' || event.key === 'Esc') && openWrapper) close(openWrapper);
  });
})();
